module.exports = __webpack_public_path__ + "img/photo-projects-gameboy-eoi.d5d852a1.png";